import { render } from "./MetasData.vue?vue&type=template&id=4097a23c&scoped=true"
import script from "./MetasData.vue?vue&type=script&lang=js"
export * from "./MetasData.vue?vue&type=script&lang=js"

import "./MetasData.vue?vue&type=style&index=0&id=4097a23c&scoped=true&lang=scss"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4097a23c"]])

export default __exports__